import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Lucía', 'Carla', 'Sofía', 'Ana', 'Paula', 'Valentina', 'Camila', 'Florencia'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showNotification = () => {
      // Random data
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      const time = Math.floor(Math.random() * 15) + 2; // 2 to 17 minutes ago
      setNotification({
        name,
        city,
        time
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 4000);
    // Loop
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * (12000 - 8000) + 8000 + 4000); // Random between 8-12s + 4s display time
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className={`fixed bottom-4 right-4 z-50 transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-1">
      <div className="bg-white/95 backdrop-blur-sm border border-[#8B9D83]/20 shadow-lg rounded-lg p-4 flex items-center gap-3 max-w-xs" data-id="element-2">
        <div className="bg-[#8B9D83]/10 p-2 rounded-full" data-id="element-3">
          <CheckCircle2 className="w-5 h-5 text-[#8B9D83]" data-id="element-4" />
        </div>
        <div data-id="element-5">
          <p className="text-sm text-[#2C2C2C] font-medium leading-tight" data-id="element-6">
            <span className="font-semibold" data-id="element-7">{notification.name}</span> –{' '}
            {notification.city}
          </p>
          <p className="text-xs text-[#6B6B6B] mt-0.5" data-id="element-8">
            compró Cabeza en Calma hace {notification.time} minutos
          </p>
        </div>
      </div>
    </div>;
}